<div class="toolbar">
    <h3>Sales Comparables</h3>
    <div class="tools">
        <!-- <button class="btn" (click)="autoSize()">Auto Size</button> -->
        <button class="btn" (click)="exportToXlsx()">Export</button>
    </div>
</div>

<ag-grid-angular class="ag-theme-alpine grid" [rowData]="rows$ | async" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [animateRows]="true" [rowSelection]="'multiple'"
    [suppressMenuHide]="true" (gridReady)="onGridReady($event)">
</ag-grid-angular>